module.exports = __webpack_public_path__ + "pc/img/img_02.729518f8.png";